import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageview } from "@/utils/analytics";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Envia um evento de pageview a cada mudança de rota
    pageview(location.pathname + location.search);
  }, [location]);

  return null; // Este componente não renderiza nada
}